import { useIsMobile } from '@/hooks/useSizeBreakpoints'
import { Plugin, Template, TemplatePlaceholder, TemplateConnector } from '@devexpress/dx-react-core'
import { Button, ButtonProps } from '@mui/material'
import { useTranslation } from 'react-i18next'

const pluginDependencies = [{ name: 'Toolbar' }]

type AddScheduleButtonProps = ButtonProps

export function AddScheduleButton(props: AddScheduleButtonProps) {
  const {t} = useTranslation()
  const label = useIsMobile() ? t('page.agenda.addScheduleMobileButton.label') : t('page.agenda.addScheduleButton.label')
  return (
    <Plugin name="TodayButton" dependencies={pluginDependencies}>
      <Template name="toolbarContent">
        <TemplatePlaceholder />
        <TemplateConnector>
          {() => {
            return <Button data-testid="add-schedule-button" {...props}>{label}</Button>
          }}
        </TemplateConnector>
      </Template>
    </Plugin>
  )
}
